<div class="white-section py-3 px-lg-5 px-md-4 px-3">
  <a class="back-link" routerLink="/account/login"><span class="material-icons">arrow_back_ios</span> Return to Log In Page</a>

  <!-- Select Forgot Username or Password -->
  @if (showScreen==='LoginHelp') {
    <div>
      <h1 class="section-header">Username / Password Help</h1>
      <p><b>Please choose one of the following options:</b></p>
      <div class="d-inline-block text-left">
        <div class="custom-control custom-radio">
          <input type="radio" [(ngModel)]="helpType" class="custom-control-input" id="forgotusername" name="loginHelpType" value="forgotusername">
          <label class="custom-control-label" for="forgotusername">Forgot Username</label>
        </div>
        <div class="custom-control custom-radio my-3">
          <input type="radio" [(ngModel)]="helpType" class="custom-control-input" id="forgotpassword" name="loginHelpType" value="forgotpassword">
          <label class="custom-control-label" for="forgotpassword">Forgot Password</label>
        </div>
      </div>
      <p>If you have forgotten both your username and password, Please contact <a href="mailto:clientservices@nicolawealth.com">clientservices&#64;nicolawealth.com</a></p>
      <button (click)="setHelpType()" class="btn-primary w-100" [disabled]="helpType===''">Next</button>
    </div>
  }

  <!-- Forgot Username -->
  @if (showScreen==='ForgotUserName') {
    <div>
      <h1 class="section-header">Forgot Username</h1>
      <p>Please enter your email address and password.</p>
      <form (ngSubmit)="submit()">
        <div class="form-group">
          <label for="forgot-username-email-address">Email Address</label>
          <input id="forgot-username-email-address" type="text" class="form-control" name="email" [(ngModel)]="email" autocomplete="off" required [disabled]="sentcode" />
          @if (sentcode) {
            <i class="fa fa-check checkIcon"></i>
          }
        </div>
        <div class="form-group">
          <label for="forgot-username-password-field">Nicola Wealth Client Web Password</label>
          <input id="forgot-username-password-field" type="password" class="form-control" name="password" [(ngModel)]="password" autocomplete="off" required [disabled]="sentcode" />
          <span class="material-icons-outlined passwordEye">visibility</span>
          @if (sentcode) {
            <i class="fa fa-check checkIcon"></i>
          }
        </div>
        @if (!sentcode) {
          <div class="row"><div class="col-3 offset-5"><caps-lock /></div></div>
          <button class="btn-primary w-100" [disabled]="email==='' || password===''">Submit</button>
          @if (errorMsg) {
            <div class="alert alert-danger mb-3">{{errorMsg}}</div>
          }
        }
      </form>
      @if (sentcode) {
        <nwm-tfa [providers]="TfaProviders" [IsForgotUsernamePassword]="true" (timeOut)="tfaTimeOut()" (tfaSuccess)="tfaPassed($event)" />
      }
    </div>
  }

  <!-- Forgot Username - Show UserName -->
  @if (showScreen==='UserName') {
    <div>
      <h1 class="section-header">Forgot Username</h1>
      <p>Please find your username below.<br>Feel free to log into your secure client access website at any time.</p>
      <p class="pb-3">Username:&nbsp;&nbsp;<b>{{username}}</b></p>
      <button (click)="authorize(user!)" class="btn btn-NWM my-3 btn-large">Log In</button>
    </div>
  }

  <!-- Forgot Password -->
  @if (showScreen==='ForgotPassword') {
    <div>
      <h1 class="section-header">Password Assistance</h1>
      <p>Please enter your email address and username.</p>
      <form (ngSubmit)="submit()">
        <div class="form-group">
          <label for="forgot-pass-email-address">Email Address</label>
          <input id="forgot-pass-email-address" type="text" class="form-control" name="email" [(ngModel)]="email" autocomplete="off" required [disabled]="sentcode" />
          @if (sentcode) {
            <i class="fa fa-check checkIcon"></i>
          }
        </div>
        <div class="form-group">
          <label for="forgot-pass-username">Username</label>
          <input id="forgot-pass-username" type="text" class="form-control" name="username" [(ngModel)]="username" autocomplete="off" required [disabled]="sentcode" />
          @if (sentcode) {
            <i class="fa fa-check checkIcon"></i>
          }
        </div>
        @if (!sentcode) {
          <div class="row"><div class="col-3 offset-5"><caps-lock /></div></div>
          <button class="btn-primary w-100" [disabled]="email==='' || username===''">Submit</button>
          @if (errorMsg) {
            <div class="alert alert-danger mb-3">{{errorMsg}}</div>
          }
        }
      </form>
      @if (sentcode) {
        <nwm-tfa [providers]="TfaProviders" [isPasswordReset]="true" [IsForgotUsernamePassword]="true" (timeOut)="tfaTimeOut()" (tfaSuccess)="tfaPassed($event)" />
      }
    </div>
  }

  <!-- Password Reset -->
  @if (showScreen==='ResetPassword') {
    <div>
      <h1 class="section-header">Welcome, {{resetPassword!.FirstName}}</h1>
      @if (!sentcode) {
        <p>Click "Next" below to proceed with your password reset.</p>
        <button class="btn-primary w-100 my-3" (click)="sentcode = true">Next</button>
        @if (errorMsg) {
          <div class="alert alert-danger mb-3">{{errorMsg}}</div>
        }
      }
      @if (sentcode) {
        <nwm-tfa [providers]="resetPassword!.tokenProviders" [isPasswordReset]="true" (timeOut)="tfaTimeOut()" (tfaSuccess)="tfaPassed($event)" />
      }
    </div>
  }

  <!-- Registration -->
  @if (showScreen==='Registration') {
    <div>
      <h1 class="section-header" style="font-size:32px">Thank you for registering, {{resetPassword!.FirstName}}<br/>Welcome to your Nicola Wealth<br />private client access website</h1>
      @if (!sentcode) {
        <p>Click "Next" below to begin your registration process.</p>
        <button class="btn-primary w-100 my-3" (click)="showScreen='IdQuestion'">Next</button>
        @if (errorMsg) {
          <div class="alert alert-danger mb-3">{{errorMsg}}</div>
        }
      }
    </div>
  }

  <!-- Identification Questions -->
  @if (showScreen==='IdQuestion') {
    <div>
      <ng-container *ngTemplateOutlet="progressBar;context:{step:1}" />
      <p class="pt-4 pb-3">Let's start by confirming your identification.</p>
      <nwm-tfa [providers]="resetPassword!.tokenProviders" [isPasswordReset]="true" (timeOut)="tfaTimeOut()" (tfaSuccess)="tfaPassed($event)" />
    </div>
  }

  <!-- Disclaimer *ngIf="showScreen=='Disclaimer'" -->
  @if (showScreen==='Disclaimer') {
    <div>
      <ng-container *ngTemplateOutlet="progressBar;context:{step:2}" />
      <p class="progress-header mt-4">Legal And Security Disclaimer</p>
      <div class="text-left mx-3">
        <ng-container>
          <p><b>Our Terms of Use</b></p>
          <p>By signing up, I consent to the personal information handling practices as outlined in the
            <a target="_blank" [href]="reRg?.IsPershing ? 'https://www.nicolawealth.com/legal#us-privacy-policy' : 'https://www.nicolawealth.com/legal#canadian-privacy-policy'">
            Privacy Policy.</a>
          </p>
          <p> I also confirm that I understand my responsibilities in securing my account details as outlined in the <a target="_blank" href="https://www.nicolawealth.com/legal#terms-conditions">Terms and Conditions.</a></p>
        </ng-container>
      </div>
      <button class="btn-primary mb-3" (click)="acceptDisclaimer()">Accept</button>&nbsp;
      <button class="btn-secondary ml-5 mb-3" type="button" data-toggle="modal" data-target="#declineDisclaimerModal">Decline</button>
    </div>
  }

  <!-- Set New Password -->
  @if (showScreen==='PasswordForm') {
    <div>
      @if (isRegistration) {
        <ng-container *ngTemplateOutlet="progressBar;context:{step:3}" />
        <p class="progress-header mt-4">Set Your New Password</p>
      }
      @if (!isRegistration) {
        <h1 class="section-header">Set Your New Password</h1>
      }
      <form (ngSubmit)="f.form.valid && submitPassword()" (change)="validatePasswords(f.form)" #f="ngForm">
        <div class="form-group">
          <label for="new-password">New Password</label>
          @if (f.dirty && passwordErrorMessage) {
            <div class="text-alert pull-right">{{passwordErrorMessage}}</div>
          }
          <input id="new-password" type="password" class="form-control" name="password" [(ngModel)]="password"
            validateEqual="confirmPassword"
            reverse="true"
            minlength="{{config.passwordRules.minLength}}"
            maxlength="{{config.passwordRules.maxLength}}"
            required
            />
            <span class="material-icons-outlined passwordEye">visibility</span>
          </div>
          <div class="form-group">
            <label for="confirm-password">Confirm Password</label>
            @if (confirmPasswordErrorMessage) {
              <div class="text-alert pull-right">{{confirmPasswordErrorMessage}}</div>
            }
            <input id="confirm-password" type="password" class="form-control" name="confirmPassword" [(ngModel)]="confirmPassword"
              validateEqual="password" reverse="false"
              maxlength="{{config.passwordRules.maxLength}}" />
              <span class="material-icons-outlined passwordEye">visibility</span>
            </div>
            <caps-lock />
            <p>
              The password must contain at least 12 characters.
            </p>
            <button class="btn-primary w-100 my-3">Next</button>
            @if (errorMsg) {
              <div class="alert alert-danger mb-3">{{errorMsg}}</div>
            }
          </form>
        </div>
      }

      <p class="my-4">
        If you encounter any difficulties logging in,
        please contact us at <a href="mailto:clientservices@nicolawealth.com">clientservices&#64;nicolawealth.com</a>. Our support team is available Monday to Friday, 8am to 5pm PST.
      </p>

      <nwm-awards />
    </div>

    <div class="modal fade" id="declineDisclaimerModal" tabindex="-1" role="dialog" aria-labelledby="declineDisclaimerModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="h5-text modal-title" id="declineDisclaimerModalLabel">Warning Message</div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            By declining to accept the parameters of this site’s legal and security disclaimer, you will not be able to proceed with Private Client Access registration.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn-primary" (click)="declineDisclaimer()">I DECLINE</button>
            <button type="button" class="btn-secondary" data-dismiss="modal">TAKE ME BACK</button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #progressBar let-step="step">
      @if (step > 0) {
        <div class="progress-row d-sm-table mt-3">
          <div class="d-sm-table-cell" [ngClass]="{'highlighted':step>0 }"><span>Identification</span></div>
          <div class="d-sm-table-cell" [ngClass]="{'highlighted':step>1 }"><span>Disclaimer Agreement</span></div>
          <div class="d-sm-table-cell" [ngClass]="{'highlighted':step>2 }"><span>Set New Password</span></div>
          <div class="d-sm-table-cell"><span>Login</span></div>
        </div>
      }
    </ng-template>
